<app-skeleton *ngIf="loadingBroadcast" variant="text" [count]="8"
  label="Carregando o broadcast de WhatsApp" data-testid="broadcast-whatsapp-loading"></app-skeleton>

<div *ngIf="!loadingBroadcast && broadcastType; else selectBroadcastType">
  <header class="page-head">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-bullhorn"></i></span>
      <div>
        <h1 class="page-head__title">{{ title }}</h1>
      </div>
    </div>
    <div class="page-head__actions">
      <a
        *ngIf="broadcastId"
        [routerLink]="['/broadcasts-whatsapp/new']"
        class="sf-btn sf-btn--secondary me-2"
      >
        <i class="fa fa-envelope-o"></i>
        Novo Broadcast
      </a>
      <button
        class="sf-btn sf-btn--primary me-2"
        (click)="changeBroadcastType('list')"
        *ngIf="broadcastType !== 'list' && !broadcast?.id"
      >
        <i class="fa fa-list"></i>
        Para Lista
      </button>
      <button
        class="sf-btn sf-btn--secondary me-2"
        (click)="changeBroadcastType('number')"
        *ngIf="broadcastType !== 'number' && !broadcast?.id"
      >
        <i class="fa fa-phone"></i>
        Para Números
      </button>
      <button
        class="sf-btn sf-btn--secondary"
        (click)="changeBroadcastType('client')"
        *ngIf="isAdministrator"
      >
        <i class="fa fa-user"></i>
        Para Clientes
      </button>
    </div>
  </header>

  <div
    class="alert alert-info broadcast-notice"
    role="status"
    *ngIf="broadcast?.id && isImporting(broadcast)"
    data-testid="broadcast-importing"
  >
    <i class="fa fa-info-circle"></i>
    <span>Os Leads deste Broadcast estão sendo importados. Assim que finalizar você
    será notificado.</span>
  </div>

  <form [formGroup]="broadcastForm" (submit)="save()">
    <div class="sf-card broadcast-card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Automação</label>
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="name"
                #nameInput
              />
              <small
                *ngIf="broadcastForm.get('name').errors?.required"
                class="text-danger"
              >
                Preencha o nome da automação
              </small>
              <small
                *ngIf="broadcastForm.get('name').errors?.minlength"
                class="text-danger"
              >
                O nome da automação deve ter pelo menos 5 caracteres
              </small>
            </div>
          </div>

          <div class="col-12" *ngIf="broadcastType === 'list'">
            <div class="form-group">
              <label>Lista</label>
              <app-skeleton *ngIf="loadingLists" variant="text" [count]="1"
                label="Carregando as listas" data-testid="lists-loading"></app-skeleton>
              <select
                name="list"
                id="list"
                class="form-control"
                formControlName="lead_list_id"
                *ngIf="!loadingLists"
              >
                <option value="ALL" *ngIf="!broadcast">Todas</option>
                <option *ngFor="let list of lists" [value]="list.id">
                  {{ list.name + " (" + list.leads_count + ")" }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 mt-2" *ngIf="broadcastType === 'client'">
            <label>Tipo de cliente:</label>
            <div class="d-flex gap-4">
              <app-radio-button
                *ngFor="let profile of profiles"
                name="profile_{{ profile.id }}"
                [text]="profile.name"
                [value]="profile.id"
                [isCheckbox]="true"
                [checked]="profile.selected"
                (onSelect)="profile.selected = $event"
              ></app-radio-button>
            </div>
          </div>

          <div class="col-12" *ngIf="broadcastType === 'number'">
            <div class="form-group">
              <label for="numbers">Números</label>
              <textarea
                name="numbers"
                id="numbers"
                class="form-control"
                formControlName="numbers"
                rows="8"
                placeholder="Cole aqui os números um abaixo do outro ou separados por vírgulas.

Exemplo:
14999999999
11999999999
-ou-
14999999999, 11999999999"
              ></textarea>
              <small><b>Quantidade:</b> {{ numbersCount }} número(s)</small>
            </div>
          </div>

          <div class="col-md-6 mt-3 mb-3">
            <app-switcher
              display="block"
              label="Enviar Agora?"
              id="send-now"
              [(checked)]="sendNow"
            ></app-switcher>
            <div class="col-md-3 mt-3 mb-3 scheduled-date" *ngIf="!sendNow">
              <div *ngIf="!broadcastId || changeDate; else sentDateInfo">
                <mat-form-field>
                  <input matInput [ngxMatDatetimePicker]="picker" readonly placeholder="Data de agendamento" formControlName="scheduled_date" [disabled]="false">
                  <ngx-mat-datepicker-toggle matSuffix [for]="picker"></ngx-mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false"
                    [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="false"
                    [enableMeridian]="true" [disableMinute]="false" [hideTime]="false">
                  </ngx-mat-datetime-picker>
                </mat-form-field>
              </div>

              <ng-template #sentDateInfo>
                <label for="date">Agendado para: </label>
                <button
                  class="sf-btn sf-btn--primary"
                  ngbTooltip="Alterar data"
                  (click)="toggleChangeDate()"
                >
                  <i class="fa fa-clock-o"></i>
                </button>
                <br />
                <span>{{
                  broadcastForm.get("scheduled_date").value
                    | date : "dd/MM/yyyy, H:mm"
                }}</span>
              </ng-template>
            </div>
          </div>

          <div
            class="col-md-3 mt-3 mb-3"
            *ngIf="broadcastId && broadcastType === 'number'"
          >
            <app-switcher
              display="block"
              label="Excluir contatos existentes?"
              id="delete-contacts"
              [(checked)]="removeContacts"
            ></app-switcher>
          </div>

          <div class="col-12">
            <div class="alert alert-warning broadcast-notice" role="alert">
              <i class="fa fa-exclamation-triangle"></i>
              <span>
              IMPORTANTE: Após a ação de WhatsApp Massivo mudar o status para "enviado", as mensagens têm até 48 horas para serem entregues devido às verificações que podem ocorrer na plataforma WhatsApp.<br><br>
              <b class="b-left">Envios são realizados somente em dias de semana nos horários comerciais.</b>
              </span>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="message">Mensagem</label>
              <textarea
                name="message"
                id="message"
                class="form-control"
                formControlName="message"
                maxlength="500"
                rows="3"
                (blur)="setPosition($event)"
              ></textarea>
              <small
                class="pull-right"
                *ngIf="
                  broadcastForm.get('message').value;
                  else textLengthCounter
                "
              >
                {{ broadcastForm.get("message").value.length }}/500
              </small>
              <ng-template #textLengthCounter>
                <small class="pull-right">0/500</small>
              </ng-template>
              <small
                class="text text-danger"
                *ngIf="broadcastForm.get('message').errors?.maxlength"
              >
                O texto deve ter apenas 500 caracteres
              </small>
              <small
                class="text text-danger"
                *ngIf="broadcastForm.get('message').errors?.required"
              >
                Preencha a sua mensagem
              </small>
              <div class="mt-2">
                <div class="mb-2">
                  <b
                    >Variáveis que podem ser utilizadas (clique para
                    adicionar)</b
                  >
                </div>
                <label
                  *ngFor="let tag of tagsForType"
                  ngbTooltip="{{ tag.text }}"
                >
                  <span
                    class="badge bg-primary me-2"
                    (click)="addTag(tag.tag)"
                    >{{ "{" + tag.tag + "}" }}</span
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="marger"></div>
          <div class="col-12">
            <div class="form-group">
              <label for="url">Meu link</label>
              <input
                type="text"
                class="form-control"
                name="url"
                id="url"
                placeholder="Exemplo: https://exemplo.com"
                formControlName="url"
              />
              <span
                class="text-danger"
                *ngIf="broadcastForm.get('url').errors?.invalidUrl"
                >URL Inválida! Exemplo: <u>https://exemplo.com</u></span
              >
            </div>
          </div>
          <div class="marger"></div>
          <div class="col-12">
            <div class="form-group">
              <label for="url">Imagem</label>
              <input
                type="file"
                class="form-control"
                name="image"
                id="image"
                formControlName="image"
                (change)="onFileChange($event)" />
            </div>
          </div>
          <div class="base-64-image-container" *ngIf="base64Image != ''">
            <img class="base-64-image" [src]="base64Image" alt="">
            <button class="sf-btn sf-btn--danger" (click)="excluirImagemHandler($event)">Excluir imagem</button>
          </div>

          <div class="marger"></div>
        </div>

        <div class="mt-2">
          <button
            class="sf-btn sf-btn--primary me-1"
            [appLoadingButton]="isSaving"
            [disabled]="broadcastForm.invalid"
            data-testid="btn-save"
          >
            Salvar
          </button>

          <a [routerLink]="['/broadcasts']" class="sf-btn sf-btn--secondary"
            >Cancelar</a
          >
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #selectBroadcastType>
  <!-- `!loadingBroadcast` para a edição não piscar a tela de escolher o tipo
       antes de o broadcast chegar. -->
  <div *ngIf="!loadingBroadcast">
    <header class="page-head">
      <div class="page-head__identity">
        <span class="page-head__icon"><i class="fa fa-bullhorn"></i></span>
        <div>
          <h1 class="page-head__title">{{ title }}</h1>
        </div>
      </div>
    </header>
    <div class="sf-card broadcast-card select-type">
      <div class="row">
        <div class="col mt-3 mb-3">
          <button
            class="sf-btn sf-btn--lg sf-btn--primary"
            (click)="changeBroadcastType('list')"
          >
            <i class="fa fa-list"></i>
            Para Lista
          </button>
          <button
            class="sf-btn sf-btn--lg sf-btn--secondary ms-2"
            (click)="changeBroadcastType('number')"
          >
            <i class="fa fa-phone"></i>
            Para Números
          </button>
          <button
            class="sf-btn sf-btn--lg sf-btn--secondary ms-2"
            (click)="changeBroadcastType('client')"
            *ngIf="isAdministrator"
          >
            <i class="fa fa-user"></i>
            Para Clientes
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
